import { render, staticRenderFns } from "./WhatsappConsumptionsReports.vue?vue&type=template&id=0785d055&scoped=true&"
import script from "./WhatsappConsumptionsReports.vue?vue&type=script&lang=js&"
export * from "./WhatsappConsumptionsReports.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappConsumptionsReports.vue?vue&type=style&index=0&id=0785d055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0785d055",
  null
  
)

export default component.exports